export default {"src":"/_next/static/media/character-b.mono.b2a0ba38.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};